import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface Option {
  id: string | number;
  name: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  allLabel?: string;
  minWidth?: number;
  disabled?: boolean;
}

export default function DropDown({
  label,
  value,
  onChange,
  options,
  allLabel,
  minWidth = 200,
  disabled = false,
}: SelectFieldProps) {
  return (
    <FormControl sx={{ minWidth }} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {allLabel && <MenuItem value="">{allLabel}</MenuItem>}
        {options.map((opt) => (
          <MenuItem key={opt.id} value={String(opt.id)}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
